import { CONFIG } from "config";
import dayjs, { ManipulateType } from "dayjs";
import {
  Booking,
  PaymentMethod,
  PaymentStatus,
  Role,
  Source,
  User,
} from "types";

// Production allowed user IDs (always active)
const PROD_NOTIFICATION_ALLOWED_USER_IDS: string[] = [
  "20cfe53e-678f-4971-a62a-f9d4fcdbf375",
  // Add production user IDs here
];

// Development allowed user IDs (only active when REACT_APP_ENVIRONMENT === 'development')
const DEV_NOTIFICATION_ALLOWED_USER_IDS: string[] = [
  "1b9f3f90-07bf-4d95-2127-08ddb7cae32d",
  // Add development user IDs here
];
const DEV_SPONSER_ALLOWED_USER_IDS: string[] = [
  "1b9f3f90-07bf-4d95-2127-08ddb7cae32d",
  // Add development user IDs here
];
const DEV_DISCOUNT_ALLOWED_USER_IDS: string[] = [
  "1b9f3f90-07bf-4d95-2127-08ddb7cae32d",
  // Add development user IDs here
];

const isDevelopment =
  CONFIG.ENVIRONMENT === "development" ||
  process.env.REACT_APP_ENVIRONMENT === "development";

export const NOTIFICATION_ALLOWED_USER_IDS: string[] = [
  ...PROD_NOTIFICATION_ALLOWED_USER_IDS,
  ...(isDevelopment ? DEV_NOTIFICATION_ALLOWED_USER_IDS : []),
];

export const USER_ROLES = {
  li3ibRoles: [
    Role.SuperAdmin,
    Role.Li3ibAdmin,
    Role.CallCenterOperative,
    Role.Li3ibAccountant,
    Role.SubSuperAdmin,
  ],
  // any error to use li3ibRoles code
  li3ibRoles1: [
    Role.SuperAdmin,
    Role.Li3ibAdmin,
    Role.CallCenterOperative,
    Role.Li3ibAccountant,
    Role.SubSuperAdmin,
  ],
  ConsolidateRoles: [Role.Li3ibAdmin, Role.Accountant],
  CostMizeRoles: [Role.Accountant],

  walletRoles: [Role.SuperAdmin, Role.Li3ibAccountant],
  dashboardRoles: [Role.SuperAdmin, Role.Li3ibAccountant],
  sponserRoles: [Role.SuperAdmin],

  withdrawRolesAccount: [Role.Li3ibAccountant],
  withdrawRolesSuperAdmin: [Role.SuperAdmin],
  packageReportRoles: [Role.SuperAdmin, Role.Li3ibAccountant, Role.Accountant],
  WalletReportRoles: [Role.SuperAdmin, Role.Li3ibAccountant],
  CustomerWalletReportRoles: [Role.SuperAdmin, Role.Li3ibAccountant],
  companyViewRoles: [Role.SuperAdmin, Role.SubSuperAdmin],
  clientRoles: [Role.ClientAdmin, Role.Coordinator, Role.Accountant],
  notificationRole: [Role.SuperAdmin],
  notificationUserIds: NOTIFICATION_ALLOWED_USER_IDS,
  hasdiscountCode: [Role.SuperAdmin, Role.SubSuperAdmin],

  adminPortalRoles: [
    Role.SuperAdmin,
    Role.Li3ibAdmin,
    Role.CallCenterOperative,
    Role.Li3ibAccountant,
    Role.ClientAdmin,
    Role.Coordinator,
    Role.Accountant,
    Role.SubSuperAdmin,
  ],

  dayViewStatsLi3ibRoles: [
    Role.SuperAdmin,
    Role.Li3ibAdmin,
    Role.Li3ibAccountant,
  ],
  dayViewStatsClientRoles: [
    Role.SuperAdmin,
    Role.Li3ibAdmin,
    Role.Li3ibAccountant,
    Role.ClientAdmin,
    Role.Accountant,
  ],
  packageRoles: [
    Role.SuperAdmin,
    // Role.Li3ibAdmin,
    Role.ClientAdmin,
    Role.Li3ibAccountant,
    Role.Coordinator,
    Role.Accountant,
    Role.CallCenterOperative,
  ],
  packageRolesCancellation: [
    Role.SuperAdmin,
    Role.Li3ibAdmin,
    Role.Li3ibAccountant,
    // Role.Accountant,
    // Role.CallCenterOperative,
    Role.Li3ibAccountant,
  ],
  packagemaster: [
    Role.SuperAdmin,
    Role.Li3ibAdmin,
    Role.Li3ibAccountant,
    // Role.Accountant,
    // Role.CallCenterOperative,
    // Role.Li3ibAccountant,
  ],
  packageCooridntor: [
    Role.SuperAdmin,
    Role.Li3ibAdmin,
    Role.Li3ibAccountant,
    Role.Accountant,
    Role.CallCenterOperative,
    Role.Coordinator,
    Role.Li3ibAccountant,
  ],
  reatingPermission: [
    Role.SuperAdmin,
    // Role.Li3ibAdmin,
    // Role.Li3ibAccountant,
    // Role.Accountant,
    // Role.CallCenterOperative,
    // Role.Coordinator,
    // Role.Li3ibAccountant,
    // Role.ClientAdmin,
  ],
  bookingPermission: [
    Role.SuperAdmin,
    Role.Li3ibAdmin,
    Role.Li3ibAccountant,
    Role.Accountant,
    Role.CallCenterOperative,
    Role.Coordinator,
    Role.Li3ibAccountant,
    Role.ClientAdmin,
  ],
  fixedbookingPermission: [
    Role.SuperAdmin,
    Role.Li3ibAdmin,
    Role.Li3ibAccountant,
    Role.Accountant,
    Role.CallCenterOperative,
    Role.Coordinator,
    Role.Li3ibAccountant,
    Role.ClientAdmin,
  ],
  dayViewPermission: [
    Role.SuperAdmin,
    Role.Li3ibAdmin,
    Role.Li3ibAccountant,
    Role.Accountant,
    Role.CallCenterOperative,
    Role.Coordinator,
    Role.Li3ibAccountant,
    Role.ClientAdmin,
  ],
  WeekViewPermission: [
    Role.SuperAdmin,
    Role.Li3ibAdmin,
    Role.Li3ibAccountant,
    Role.Accountant,
    Role.CallCenterOperative,
    Role.Coordinator,
    Role.Li3ibAccountant,
    Role.ClientAdmin,
  ],
  hasSportView: [
    Role.SuperAdmin,
    Role.Li3ibAdmin,
    Role.Li3ibAccountant,
    Role.Accountant,
    Role.CallCenterOperative,
    Role.Coordinator,
    Role.Li3ibAccountant,
  ],
  hasanmititesView: [
    Role.SuperAdmin,
    Role.Li3ibAdmin,
    Role.Li3ibAccountant,
    Role.Accountant,
    Role.CallCenterOperative,
    Role.Coordinator,
    Role.Li3ibAccountant,
  ],
  hasExpensesView: [
    Role.SuperAdmin,
    Role.Li3ibAdmin,
    Role.Li3ibAccountant,
    Role.Accountant,
    Role.CallCenterOperative,
    Role.Coordinator,
    Role.Li3ibAccountant,
  ],
  hasCompanyInfoView: [
    Role.SuperAdmin,
    Role.Li3ibAdmin,
    Role.Li3ibAccountant,
    Role.Accountant,
    Role.CallCenterOperative,
    Role.Coordinator,
    Role.Li3ibAccountant,
    Role.ClientAdmin,
  ],
  companyInfoTermrRoles: [Role.SuperAdmin],
  all: Object.values(Role),
};

export const hasDayViewStatsLi3ibRoles = (user: User) =>
  USER_ROLES.dayViewStatsLi3ibRoles.includes(user.role);

export const hasDayViewStatsClientRoles = (user: User) =>
  USER_ROLES.dayViewStatsClientRoles.includes(user.role);

export const hasLi3ibRole = (user: User) =>
  USER_ROLES.li3ibRoles.includes(user.role);

export const hasConsolidateRole = (user: User) =>
  USER_ROLES.ConsolidateRoles.includes(user.role);

export const hasCostmizeRole = (user: User) =>
  USER_ROLES.CostMizeRoles.includes(user.role);

export const hasPackageReRole = (user: User) =>
  USER_ROLES.packageReportRoles.includes(user.role);

export const hasWalletReRole = (user: User) =>
  USER_ROLES.WalletReportRoles.includes(user.role);

export const hasCustomerWalletReRole = (user: User) =>
  USER_ROLES.CustomerWalletReportRoles.includes(user.role);

export const hasWalletRole = (user: User) =>
  USER_ROLES.walletRoles.includes(user.role);
export const hasNotificationRole = (user: User) => {
  const hasRole = USER_ROLES.notificationRole.includes(user.role);
  const isAllowedUser = Boolean(
    user?.id && NOTIFICATION_ALLOWED_USER_IDS.includes(user.id)
  );

  return hasRole || isAllowedUser;
};
export const hasWithdrawApproveRole = (user: User) =>
  USER_ROLES.withdrawRolesAccount.includes(user.role);

export const hasWithdrawPaymentViewRole = (user: User) =>
  USER_ROLES.withdrawRolesAccount.includes(user.role);

export const hasWithdrawSuperadminRole = (user: User) =>
  USER_ROLES.withdrawRolesSuperAdmin.includes(user.role);

export const hasCompanyViewRole = (user: User) =>
  USER_ROLES.companyViewRoles.includes(user.role);

export const hasCompanyReatingViewRole = (user: User) =>
  USER_ROLES.reatingPermission.includes(user.role);

export const hasBookingViewRole = (user: User) =>
  USER_ROLES.bookingPermission.includes(user.role);

export const hasFixedBookingViewRole = (user: User) =>
  USER_ROLES.fixedbookingPermission.includes(user.role);

export const hasdayViewViewRole = (user: User) =>
  USER_ROLES.dayViewPermission.includes(user.role);

export const haswekViewViewRole = (user: User) =>
  USER_ROLES.WeekViewPermission.includes(user.role);

export const hasClientRole = (user: User) =>
  USER_ROLES.clientRoles.includes(user.role);

export const hasDashBoadRole = (user: User) =>
  USER_ROLES.dashboardRoles.includes(user.role);
export const hasdiscountCodeRole = (user: User) => {
  const hasRole = USER_ROLES.hasdiscountCode.includes(user.role);
  const isAllowedUser = Boolean(
    user?.id && DEV_DISCOUNT_ALLOWED_USER_IDS.includes(user.id)
  );
  
return hasRole || isAllowedUser;
};

export const hasDiscountOfferRole = (user: User) => {
  const hasRole = USER_ROLES.hasdiscountCode.includes(user.role);
  
return hasRole;
};

export const hasSponserRole = (user: User) => {
  const hasRole = USER_ROLES.sponserRoles.includes(user.role);
  const isAllowedUser = Boolean(
    user?.id && DEV_SPONSER_ALLOWED_USER_IDS.includes(user.id)
  );
  
return hasRole || isAllowedUser;
};

export const allAvailableRolesExceptUser = (user: User) => {
  if (user.role === Role.Li3ibAdmin) {
    return USER_ROLES.all.filter(
      (role) => ![Role.User, Role.SuperAdmin].includes(role)
    );
  }

  return USER_ROLES.all.filter((role) => role !== Role.User);
};

export const allAvailableRolesForLoggedInUser = (user: User) => {
  if (user.role === Role.Li3ibAdmin) {
    return USER_ROLES.all.filter((role) => ![Role.SuperAdmin].includes(role));
  }

  return USER_ROLES.all;
};
export const haspackageRoles = (user: User) =>
  USER_ROLES.packageRoles.includes(user.role);
export const hascompanyInfoTerm = (user: User) =>
  USER_ROLES.companyInfoTermrRoles.includes(user.role);
export const haspackageCancellation = (user: User) =>
  USER_ROLES.packageRolesCancellation.includes(user.role);
export const haspackageMaster = (user: User) =>
  USER_ROLES.packagemaster.includes(user.role);
export const haspackageCooridantor = (user: User) =>
  USER_ROLES.packageCooridntor.includes(user.role);
export const hasSportViewPermission = (user: User) =>
  USER_ROLES.hasSportView.includes(user.role);
export const hasExpensesViewPermission = (user: User) =>
  USER_ROLES.hasExpensesView.includes(user.role);
export const hasCompanyInfoViewPermission = (user: User) =>
  USER_ROLES.hasCompanyInfoView.includes(user.role);

export const anmititesViewpermison = (user: User) =>
  USER_ROLES.hasanmititesView.includes(user.role);

const isGlobalAdmin = (user: User) =>
  user.role === Role.SuperAdmin ||
  user.role === Role.Li3ibAdmin ||
  user?.role === Role.SubSuperAdmin;
const isManagingRole = (user: User) => user.role === Role.SuperAdmin;
// || user.role === Role.Li3ibAdmin
// || user.role === Role.CallCenterOperative;

const canManageUsers = (user: User) =>
  [Role.SuperAdmin, Role.SubSuperAdmin].includes(user.role);

const canViewUsersApp = (user: User) => user.role === Role.SuperAdmin;

const canViewUsersAdmin = (user: User) =>
  [Role.SuperAdmin, Role.SubSuperAdmin].includes(user.role);

const isAdminPortalUser = (user: User) =>
  USER_ROLES.adminPortalRoles.includes(user.role);
const isAccountantRole = (user: User) =>
  user.role === Role.SuperAdmin ||
  user.role === Role.Li3ibAdmin ||
  user.role === Role.Li3ibAccountant ||
  user.role === Role.ClientAdmin ||
  user.role === Role.Accountant;

const isAccountant = (user?: User) => user?.role === Role.Accountant;

const isOnlyLi3ibAccountantRole = (user: User) =>
  user.role === Role.Li3ibAccountant;

export type Permissions = ReturnType<typeof getUserPermissions>;
export type PermissionKey = NestedKeyOf<Permissions>;

export const getUserPermissions = (user: User) => {
  return {
    booking: {
      view: hasBookingViewRole(user),
    },
    Fixedbooking: {
      view: hasFixedBookingViewRole(user),
    },
    dayView: {
      view: hasdayViewViewRole(user),
    },
    weekView: {
      view: haswekViewViewRole(user),
    },
    company: {
      add: isGlobalAdmin(user),
      edit: isGlobalAdmin(user),
      select: hasLi3ibRole(user),
      view: hasCompanyViewRole(user),
    },
    companyType: {
      select: hasLi3ibRole(user),
    },
    facility: {
      select: isAdminPortalUser(user),
    },
    facilities: {
      view: hasLi3ibRole(user),
      create: isGlobalAdmin(user),
      edit: isGlobalAdmin(user),
    },
    fields: {
      view: hasLi3ibRole(user),
      add: isGlobalAdmin(user),
      edit: isGlobalAdmin(user),
    },
    source: {
      view: hasLi3ibRole(user),
    },
    community: {
      view: isManagingRole(user),
      edit: isManagingRole(user),
    },
    notification: {
      view: hasNotificationRole(user),
      edit: hasNotificationRole(user),
    },
    social: {
      view: isManagingRole(user),
      edit: isManagingRole(user),
    },
    userLevel: {
      view: isManagingRole(user),
      edit: isManagingRole(user),
    },
    users: {
      view: canManageUsers(user),
      edit: canManageUsers(user),
    },

    usersApp: {
      view: canViewUsersApp(user),
    },

    usersAdmin: {
      view: canViewUsersAdmin(user),
    },
    amenities: {
      view: isGlobalAdmin(user),
      edit: isGlobalAdmin(user),
    },
    sports: {
      view: isGlobalAdmin(user),
      edit: isGlobalAdmin(user),
    },
    sportsViewpermison: {
      view: hasSportViewPermission(user),
    },
    anmititesViewpermison: {
      view: hasSportViewPermission(user),
    },
    companyInfoViewpermison: {
      view: hasCompanyInfoViewPermission(user),
    },
    ExpensesViewpermison: {
      view: hasExpensesViewPermission(user),
    },
    adminUsers: {
      view: isGlobalAdmin(user),
      edit: isGlobalAdmin(user),
    },
    withdraw: {
      view: hasWalletRole(user),
      paymentMethodView: hasWithdrawPaymentViewRole(user),
    },
    withdrawapprove: {
      view: hasWithdrawApproveRole(user),
    },
    withdrawSuperadmin: {
      view: hasWithdrawSuperadminRole(user),
    },
    wallet: {
      view: hasWalletRole(user),
    },
    package: {
      view: haspackageRoles(user),
      edit: haspackageRoles(user),
    },
    reports: {
      view: isAccountantRole(user),
    },
    reating: {
      view: hasCompanyReatingViewRole(user),
    },
    allWalletReports: {
      view: isOnlyLi3ibAccountantRole(user),
    },
    companyinfoterm: {
      view: hascompanyInfoTerm(user),
    },
    cancellationPackage: {
      view: haspackageCancellation(user),
    },
    packageMaster: {
      view: haspackageMaster(user),
    },
    dashboardView: {
      view: hasDashBoadRole(user),
    },
    discountCode: {
      view: hasdiscountCodeRole(user),
      edit: hasdiscountCodeRole(user),
    },
    discountOffers: {
      view: hasDiscountOfferRole(user),
      edit: hasDiscountOfferRole(user),
    },
    sponserView: {
      view: hasSponserRole(user),
      edit: hasSponserRole(user),
    },
  };
};

/** Booking view and edit permissions */
// const isBeforeBookingStart = (booking: Booking) =>
//   dayjs(new Date()).isBefore(booking.start_date);

const isBeforeBookingEnd = (booking: Booking) =>
  dayjs(new Date()).isBefore(booking.end_date);

const isAfterBookingStartWithExtraTime = (
  booking: Booking,
  extraAmount: number,
  unit: ManipulateType
) =>
  dayjs(new Date()).isAfter(
    dayjs(booking.start_date).subtract(extraAmount, unit)
  );

const isBeforeBookingEndWithExtraTime = (
  booking: Booking,
  extraAmount: number,
  unit: ManipulateType
) => dayjs(new Date()).isBefore(dayjs(booking.end_date).add(extraAmount, unit));

const isAllowedAddAndCancelPastBooking = (date: any) => {
  // Get the current date and time
  const bookingDate = new Date(date);

  // Get the current date and time
  const currentDate = new Date();

  // Calculate the difference in milliseconds
  const differenceInMilliseconds =
    currentDate.getTime() - bookingDate.getTime();

  // Convert milliseconds to hours
  const differenceInHours = differenceInMilliseconds / (1000 * 60 * 60);

  // console.log(differenceInHours);

  // Check if the difference is exactly 24 hours
  return differenceInHours <= 24;
};

const canEditAllSourceBookings = (user: User) =>
  // [Role.SuperAdmin, Role.Li3ibAdmin, Role.CallCenterOperative].includes(
  //   user.role,
  // );
  [Role.SuperAdmin, Role.Li3ibAdmin, Role.CallCenterOperative].includes(
    user.role
  );

const hasAddOrEditPastBookings = (user: User) =>
  [
    Role.SuperAdmin,
    Role.Li3ibAdmin,
    Role.ClientAdmin,
    Role.CallCenterOperative,
  ].includes(user.role);

export const canAddOrCancelPastBookings = (user: User, date: any) => {
  const hasRole = hasAddOrEditPastBookings(user);

  return isAllowedAddAndCancelPastBooking(date) && hasRole;
};

const canEditClientSourceBooking = (user: User, booking: Booking) =>
  [Role.ClientAdmin].includes(user.role) &&
  (booking.source === Source.ExternalAdminPortal ||
    booking.source === Source.InternalAdminPortal);

const canEditConfirmations = (user: User) =>
  [Role.ClientAdmin, Role.Coordinator].includes(user.role);

export const canViewPhoneNumber = (user: User, booking: Booking) =>
  canEditAllSourceBookings(user) || canEditClientSourceBooking(user, booking);

const canEditPhoneNumber = (user: User, booking: Booking) =>
  isBeforeBookingEnd(booking) &&
  (canEditAllSourceBookings(user) || canEditClientSourceBooking(user, booking));

const canEditName = (user: User, booking: Booking) =>
  isBeforeBookingEnd(booking) &&
  (canEditAllSourceBookings(user) || canEditClientSourceBooking(user, booking));

const canEditDiscount = (user: User, booking: Booking) =>
  isBeforeBookingEndWithExtraTime(booking, 30, "minutes") &&
  (canEditAllSourceBookings(user) || canEditClientSourceBooking(user, booking));

export const canCancelBooking = (user: User, booking: Booking) =>
  // isBeforeBookingStart(booking) &&
  canAddOrCancelPastBookings(user, booking.start_date) &&
  !booking.is_cancelled &&
  (canEditAllSourceBookings(user) || canEditClientSourceBooking(user, booking));

export const canViewBookingAuthor = (user: User) => hasLi3ibRole(user);
export const canViewCompany = (user: User) => hasLi3ibRole(user);

const canEditPresence = (user: User, booking: Booking) => {
  if (booking.client_showed_up !== null) return false;

  return (
    isAfterBookingStartWithExtraTime(booking, 30, "minutes") &&
    isBeforeBookingEndWithExtraTime(
      booking,
      Role.Coordinator == user.role ? 30 : 1440,
      "minutes"
    ) &&
    (canEditAllSourceBookings(user) || canEditConfirmations(user))
  );
};

const canEditPayment = (user: User, booking: Booking) => {
  if (!booking?.transaction) return false;

  if (booking?.transaction?.payment_status !== PaymentStatus?.Created)
    return false;

  const hasRole = canEditAllSourceBookings(user) || canEditConfirmations(user);

  if (booking.transaction.payment_method === PaymentMethod.Cash) {
    return (
      isAfterBookingStartWithExtraTime(booking, 30, "minutes") &&
      isBeforeBookingEndWithExtraTime(
        booking,
        Role.Coordinator == user.role ? 30 : 1440,
        "minutes"
      ) &&
      hasRole
    );
  }

  return isBeforeBookingEndWithExtraTime(booking, 30, "minutes") && hasRole;
};

export const canEditBooking = (user: User, booking: Booking) => {
  if (booking.is_cancelled)
    return {
      phoneNumber: false,
      firstName: false,
      lastName: false,
      discount: false,
      payment: false,
      presence: false,
    };

  return {
    phoneNumber: canEditPhoneNumber(user, booking),
    firstName: canEditName(user, booking),
    lastName: canEditName(user, booking),
    discount: canEditDiscount(user, booking),
    payment: canEditPayment(user, booking),
    presence:
      user?.role == "SuperAdmin" ? true : canEditPresence(user, booking),
  };
};

export const canEditCompany = (user: User) => {
  const canEditCompanyPermission = getUserPermissions(user).company.edit;

  return {
    name: canEditCompanyPermission,
    name_arabic: canEditCompanyPermission,
    address: canEditCompanyPermission,
    country: canEditCompanyPermission,
    phone_number: canEditCompanyPermission,
    email: canEditCompanyPermission,
    geolocation: canEditCompanyPermission,
    type: canEditCompanyPermission,
  };
};

export const canCreateFacility = (user?: User) => {
  if (!user) return false;

  return getUserPermissions(user).facilities.create;
};

export const canEditField = (user?: User) => {
  if (!user) return false;

  return getUserPermissions(user).fields.edit;
};

export const canDownloadAccountsReport = (user?: User) => {
  if (!user) return false;

  return hasLi3ibRole(user);
};
export const canConsolidatedReport = (user?: User) => {
  if (!user) return false;

  return hasConsolidateRole(user) && !isAccountant(user);
};

export const canCoutmoizeReport = (user?: User) => {
  if (!user) return false;

  return hasCostmizeRole(user);
};
export const canpackageReportRoles = (user?: User) => {
  if (!user) return false;

  return hasPackageReRole(user) && !isAccountant(user);
};
export const canWalletReportRoles = (user?: User) => {
  if (!user) return false;

  return hasWalletReRole(user);
};
export const canWalletCustomerReportRoles = (user?: User) => {
  if (!user) return false;

  return hasCustomerWalletReRole(user);
};

export const canViewDayViewLi3ibStats = (user?: User) => {
  if (!user) return false;

  return hasDayViewStatsLi3ibRoles(user);
};

export const canViewDayViewClientStats = (user?: User) => {
  if (!user) return false;

  return hasDayViewStatsClientRoles(user);
};
